<template>
  <tr>
    <td class="text-left">
      <router-link :to="{name: 'client_dashboard', params: {'client_id': consult.client}}">
        {{ consultClientName }}
      </router-link>
    </td>
    <td class="text-left">
      {{ consultClientCode }}
    </td>
    <td class="text-left">
      {{ getConsultState }}
    </td>
    <td class="text-left">
      {{ consultType | unslugify }}
    </td>
    <td class="text-left">
      <template v-if='consultType == "winter_consult"'>
        <winter-consult-actions :consult="consult"
                :consultSeason="consultSeason"
                @consult-changed="consultChanged"
                @consult-deleted="consultChanged">
        </winter-consult-actions>
      </template>
      <template v-if='consultType == "general_farm_consult"'>
        <general-farm-consult-actions :consult="consult"
                :consultSeason="consultSeason"
                @consult-changed="consultChanged"
                @consult-deleted="consultChanged">
        </general-farm-consult-actions>
      </template>
      <template v-if='consultType == "dry_cow_consult"'>
        <dry-cow-consult-actions :consult="consult"
                :consultSeason="consultSeason"
                @consult-changed="consultChanged"
                @consult-deleted="consultChanged">
        </dry-cow-consult-actions>
      </template>
      <template v-if='consultType == "spring_consult"'>
        <spring-consult-actions :consult="consult"
                :consultSeason="consultSeason"
                @consult-changed="consultChanged"
                @consult-deleted="consultChanged">
        </spring-consult-actions>
      </template>
    </td>
  </tr>
</template>

<script>
import { unslugify, get_dairy_season_start_year } from '../_helpers/utils'
import DryCowConsultActions from './consult_actions/DryCowConsultActions'
import GeneralFarmConsultActions from './consult_actions/GeneralFarmConsultActions'
import SpringConsultActions from './consult_actions/SpringConsultActions'
import WinterConsultActions from './consult_actions/WinterConsultActions'

export default {
  components: {
    DryCowConsultActions,
    GeneralFarmConsultActions,
    SpringConsultActions,
    WinterConsultActions,
  },
  props: ['consult', 'consultType'],
  filters: {
    unslugify: unslugify
  },
  methods: {
    consultChanged: function ()
    {
      let consultData = {client: this.consult.client, consultType: this.consultType}
      this.$emit('consult-changed', consultData)
    }
  },
  computed: {
    consultClientName: function ()
    {
      if (typeof this.consult.models != 'object') { return ''}
      if (this.consult.models == null) {return ''}
      if (!this.consult.models) { return '' }
      let modelName = (this.consultType == 'general_farm_consult') ? 'Client' : 'ClientDetails'
      // TODO: remove wrong data from idb if present
      if (!(modelName in this.consult.models ))
      {
        return ''
      }

      let name = (this.consultType == 'general_farm_consult')
        ? this.consult.models.Client.full_name
        : this.consult.models.ClientDetails.full_name
      let company = (this.consultType == 'general_farm_consult')
        ? this.consult.models.Client.company
        : this.consult.models.ClientDetails.company

      return ((company || '').trim() && (name || '').trim())
        ? `${name} - ${company}`
        : (((name || '').trim()) ? name : company)
    },
    consultClientCode: function ()
    {
      return (this.consultType == 'general_farm_consult')
        ? this.consult.models.Client.client_code
        : this.consult.models.ClientDetails.client_code
    },
    canShowWCACtions: function ()
    {
      return Boolean(this.consultType == "winter_consult" && this.consult.models.Misc.consult_state != "finished")
    },
    consultSeason: function ()
    {
      if (this.consultType == 'general_farm_consult') {
        return this.consult.models.Misc.consult_opened_date
      }
      try {
        return this.consult.models.Misc.season_start_year
          || get_dairy_season_start_year({forWinterConsult: (this.consultType == 'winter_consult')})
      } catch (TypeError) {
        return get_dairy_season_start_year()
      }
    },
    getConsultState: function()
    {
      try {
        return  (this.consult.models.Misc.consult_state == 'finished') ? 'Completed' :  'Initial'
      } catch ( TypeError ) {
        return ''
      }
    },
  }
}
</script>
